// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1oLH6","label":"CategoryService_label__1spsY","location":"CategoryService_location__1ezUm"};